import {TabIndex} from '../enums/TabIndex';

export const chatTabs = {
  [TabIndex.RecentChats]: 'Recent Chats',
  [TabIndex.Projects]: 'Projects',
  [TabIndex.Assets]: 'Assets',
  [TabIndex.Tasks]: 'Tasks',
  [TabIndex.Requirements]: 'Requirements',
  [TabIndex.Files]: 'Files',
}